import React, { useState, useEffect } from "react";
import { Layout } from "app/images";
import "styles/auth.css";
import { FormInput } from "components/ui/FormInput";
import { Button } from "components/ui/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { ForgotPasswordAPI } from "rest/auth";
import { ButtonLoader } from "components/Loader/ButtonLoader";
import { useNotifications } from "reapop";

const forgotPasswordSchema = yup.object({
  email: yup.string()
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Email must be a valid email"
    ),
});

export default function ForgotPassword() {
  const { notify } = useNotifications();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("ForgotPassword component mounted");
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(forgotPasswordSchema) });

  const forgotPasswordMutation = ForgotPasswordAPI();

  const onSubmit = (data) => {
    forgotPasswordMutation.mutate(data, {
      onSuccess: () => {
        setIsSubmitted(true);
      },
    });
  };

  if (isSubmitted) {
    return (
      <div className="container-xxl">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner">
            <div className="card">
              <div className="card-body">
                <div className="app-brand justify-content-center">
                  <Link to="/" className="app-brand-link gap-2">
                    <span className="app-brand-logo demo">
                      <img src={Layout?.LOGO} alt="logo" className="d-block mx-auto" />
                    </span>
                  </Link>
                </div>

                <div className="text-center">
                  <div className="mb-4">
                    <div className="avatar avatar-xl mx-auto mb-3">
                      <div className="avatar-inner bg-light-primary">
                        <i className="bx bx-mail-send text-primary" style={{ fontSize: "2rem" }}>
                          📧
                        </i>
                      </div>
                    </div>
                    <h4 className="mb-2">Check your email!</h4>
                    <p className="text-muted">
                      We've sent a password reset link to your email address.
                    </p>
                  </div>
                  
                  <div className="d-flex justify-content-center">
                    <div style={{ width: "auto", minWidth: "unset" }}>
                      <Button
                        onClick={() => navigate("/login")}
                        style={{ width: "auto", padding: "8px 16px" }}
                      >
                        Back to Login
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner">
          <div className="card">
            <div className="card-body">
              <div className="app-brand justify-content-center">
                <Link to="/" className="app-brand-link gap-2">
                  <span className="app-brand-logo demo">
                    <img src={Layout?.LOGO} alt="logo" className="d-block mx-auto" />
                  </span>
                </Link>
              </div>

              <h4 className="mb-2">Forgot Password? 🔒</h4>
              <p className="mb-4">
                Enter your email address and we'll send you instructions to reset your password.
              </p>

              <form id="formAuthentication" className="mb-3" onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                  <label className="form-label" htmlFor="email">
                    Email
                  </label>
                  <FormInput
                    type="text"
                    name="email"
                    placeholder="Enter your email"
                    autoFocus
                    {...register("email")}
                  />
                  {errors?.email && (
                    <p className="errorMessage">{errors?.email?.message}</p>
                  )}
                </div>

                {forgotPasswordMutation?.isPending ? (
                  <div className="d-flex justify-content-center">
                    <ButtonLoader />
                  </div>
                ) : (
                  <Button type="submit">Send Reset Link</Button>
                )}
              </form>

              <div className="text-center">
                <Link to="/login">
                  <i className="bx bx-chevron-left scaleX-n1-rtl"></i>
                  Back to login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
